const baseURL = 'https://restaurante.logincm.com';

export default baseURL;
